<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <MarketSegmentFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import MarketSegmentFormPart from 'chimera/painting/components/form/parts/marketSegment/MarketSegmentFormPart'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import NextStep from '~/pages/offertes-aanvragen/uitvoeringsperiode'

export default {
  name: 'MarketSegmentFormStep',

  components: {
    MarketSegmentFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
